
export const createAction = <T, P>(actionType: T) => class {
  static type = actionType
  type = actionType
  constructor (public payload: P) {
    return { ...this }
  }
}
